<div class="fs-padding sync-fusion-main-container">
    <div class="fs-section-block fs-margin-0 header-background ">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <span class="mat-headline">Inventory Snapshot</span>
                <p class="fs-hint-text mt-1">Track inventory by brand and location</p>
            </div>
        </div>
    </div>
    <div class="pivot-container">
        <!-- <div class="fs-padding-0-1 mt-2">
        <span style="font-size: 20px;">Stock for Apparels</span>
        <app-pivot-table-molecule [pivotId]="'pivot1'" [rowCollection]="rowCollection" [rowField]="rowField"
            [columnCollection]="columnCollection" [columnField]="columnField"
            [rowFilters]="apparelRowFilters"></app-pivot-table-molecule>

    </div> -->
        <!-- <div>
        <mat-toolbar class="mat-toolbar justify-content-between mat-toolbar-single-row">
            <span>Stock for Accessories</span>
        </mat-toolbar>
        <div class="fs-padding-0-1">
            <app-pivot-table-molecule [pivotId]="'pivot2'" [rowCollection]="rowCollection" [rowField]="rowField"
                [columnCollection]="columnCollection" [columnField]="columnField"
                [rowFilters]="accessoryRowFilters"></app-pivot-table-molecule>
        </div>
    </div> -->
        <div *ngFor="let dashboard of dashboardConfigs; let i = index" class="mt-2">
            <!-- <span style="font-size: 20px;">{{ dashboard.title }}</span> -->
            <!-- First Pivot Table -->
            <ng-container *ngIf="i === 0; else toolbarHeader">
                <span style="font-size: 20px;padding: 0 1rem;">{{ dashboard.title }}</span>
            </ng-container>

            <!-- Toolbar Header for 2nd and more -->
            <ng-template #toolbarHeader>
                <mat-toolbar class="mat-toolbar justify-content-between mat-toolbar-single-row">
                    <span>{{ dashboard.title }}</span>
                </mat-toolbar>
            </ng-template>

            <app-pivot-table-molecule [pivotId]="'pivot' + i" [rowCollection]="dashboard.config.rowCollection"
                [rowField]="dashboard.config.rowField" [columnCollection]="dashboard.config.columnCollection"
                [columnField]="dashboard.config.columnField" [rowFilters]="dashboard.config.rowFilters || []">
            </app-pivot-table-molecule>
        </div>

    </div>
</div>